import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).join(" ");
  return e?.message || "Something went wrong";
};

export const randomQuestionPageUrl = (exclude) =>
  `${API}/question-pages/random${exclude ? `?exclude=${encodeURIComponent(exclude)}` : ""}`;

const adminHeaders = (pw) => ({ headers: { "X-Admin-Password": pw } });

export const verifyAdmin = (pw) => axios.post(`${API}/admin/verify`, {}, adminHeaders(pw));
export const fetchEntries = (pw) => axios.get(`${API}/admin/entries`, adminHeaders(pw)).then((r) => r.data);
export const uploadSheet = (pw, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/upload`, fd, adminHeaders(pw)).then((r) => r.data);
};
